// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"6f736983","878":"1e3a75bb","946":"9e7deca1"}[chunkId] + ".chunk.css";
};